import { constant } from './UserProfileActionsConstant'
let initialState = {
    getUserProfileInProgress: false,
    userInformation: null,
    data: [],
    updateUserActiveSchoolInProgress: false,
    activeProfileType: "",
    getUpdateProfileInProgress: false,
    makeOwnerInProgress: false,
    makeOwnerSuccess:false,
    makeOwnerFailure:false
}


const UserProfileReducer = (state = initialState, action) => {
    switch (action.type) {

        case constant.UPDATE_PROFILE_IN_PROGRESS:
            return { ...state, getUpdateProfileInProgress: true };
        case constant.UPDATE_PROFILE_IN_COMPLETE:
            return { ...state, getUpdateProfileInProgress: false, userInformation: action.data };
        case constant.USER_PROFILE_FETCH_IN_PROGRESS:
            return { ...state, getUserProfileInProgress: true };
        case constant.USER_PROFILE_FETCH_IN_COMPLETE:
            return { ...state, getUserProfileInProgress: false, userInformation: action.data };
        case constant.UPDATE_USER_ACTIVE_SCHOOL_IN_PROGRESS:
            return { ...state, updateUserActiveSchoolInProgress: true };
        case constant.UPDATE_USER_ACTIVE_SCHOOL_COMPLETE:
            return { ...state, updateUserActiveSchoolInProgress: false, userInformation: action.data };
        case constant.SET_ACTIVE_PROFILE_TYPE:
            return { ...state, activeProfileType: action.data };

        case constant.MAKE_OWNER_IN_PROGRESS:
            return{...state, makeOwnerInProgress:true}
            
        case constant.MAKE_OWNER_SUCCESS:
            return{...state, makeOwnerInProgress:false, makeOwnerSuccess:true}   

        case constant.MAKE_OWNER_FAILURE:
            return{...state, makeOwnerInProgress: false, makeOwnerFailure: true}    
        default:
            return state;
    }
}

export default UserProfileReducer;